import { useSyncExternalStore } from "react";

let pendingRequest = null;
const subscribers = new Set();

const emit = () => subscribers.forEach((listener) => listener());

const subscribe = (listener) => {
  subscribers.add(listener);
  return () => subscribers.delete(listener);
};

const getRequest = () => pendingRequest;

/**
 * Opens the add-moment intercept instead of silently switching the user to webcal.
 * @param {{ state: string, calendar: Object, onAddByLink: Function }} request
 * @returns {void}
 */
export const requestChannelDecision = (request) => {
  pendingRequest = request;
  emit();
};

/** Closes the add-moment intercept. */
export const clearChannelDecision = () => {
  pendingRequest = null;
  emit();
};

/** Drops everything the host is showing, e.g. on sign-out or a route change. */
export const clearGoogleConnectSurfaces = () => {
  pendingRequest = null;
  emit();
};

/**
 * The intercept the user is currently being asked to resolve.
 * @returns {{ state: string, calendar: Object, onAddByLink: Function }|null}
 */
export const usePendingChannelDecision = () =>
  useSyncExternalStore(subscribe, getRequest, getRequest);
